var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',_vm._l((_vm.selectedCards),function(card){return _c('v-col',{key:card.value,staticClass:"d-flex justify-center",attrs:{"cols":"3","md":"1","sm":"2"}},[_c('v-btn',{class:{'cur-vote': card.isActive},on:{"click":function($event){return _vm.sendVote(card)}}},[_vm._v(_vm._s(card.val))])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }